import { Component, inject } from '@angular/core';
import { AdminEditSupplierComponent } from '../../../../components/admin-dashboard-component/admin-suppliers-component/admin-edit-supplier-component/admin-edit-supplier-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-edit-supplier',
  imports: [AdminEditSupplierComponent],
  templateUrl: './admin-edit-supplier.html',
  styleUrl: './admin-edit-supplier.scss',
})
export class AdminEditSupplier {
  private route = inject(ActivatedRoute);
  supplierId = this.route.snapshot.paramMap.get('id');
}
